import SearchableSelect from './SearchableSelect';
import { ValueOf } from 'type-fest';
import { SandboxIsoStateIds } from 'SandboxModule/hooks/useSandboxes';
import useRealmSearchableSelect from './useRealmSearchableSelect';

type Props = {
  tenantName?: string;
  value: string;
  onChange: (realmId: string) => void;
  label?: string;
  labelId?: string;
  isoId?: ValueOf<typeof SandboxIsoStateIds>;
  fullWidth?: boolean;
  variant?: 'outlined' | 'standard' | 'filled';
  disableMenuMargin?: boolean;
  hideAllOption?: boolean;
  disabled?: boolean;
};

export const SearchableRealmSelect = ({
  tenantName,
  value,
  onChange,
  label = 'Realm ID',
  labelId = 'realm-select-label',
  isoId = SandboxIsoStateIds.AppbarRealmSelector,
  fullWidth = true,
  variant = 'outlined',
  disableMenuMargin = false,
  hideAllOption = false,
  disabled = false,
}: Props) => {
  const { getOptions, defaultPlaceholder } = useRealmSearchableSelect({ tenantName, isoId });

  return (
    <SearchableSelect
      value={value}
      onChange={onChange}
      label={label}
      labelId={labelId}
      fullWidth={fullWidth}
      variant={variant}
      placeholder={defaultPlaceholder}
      getOptions={getOptions}
      disableMenuMargin={disableMenuMargin}
      hideAllOption={hideAllOption}
      disabled={disabled}
    />
  );
};

export default SearchableRealmSelect;
